import { render, staticRenderFns } from "./MarqetaVirtualCard.vue?vue&type=template&id=20e5b8e2"
import script from "./MarqetaVirtualCard.vue?vue&type=script&lang=js"
export * from "./MarqetaVirtualCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports